<template>
    <div class="d-flex flex-wrap px-4">
        <div class="col-12 bg-white text-center text-lg-end p-4">
            <router-link to="/dashboard/travels/bank_cards/add" class="btn btn-lg btn-auth btn-auth-first text-decoration-none me-4 mb-5">
                {{ $t('Dashboard.BankCards.addBankCard') }}
            </router-link>
            <DataTable :tbody="BankCards" @askDelete="onAskDelete = $event" v-if="!loader && BankCards"/>
        </div>
    </div>
    <transition name="fade-modal">
        <modal v-if="onAskDelete">
            <template v-slot:body>
                <div class="d-flex flex-wrap bg-white p-4">
                    <div class="col-12 d-flex align-items-center flex-wrap mb-4">
                        <img :src="require(`@/assets/img/card_schemes/${onAskDelete.label}.svg`)" class="card-scheme">
                        <h3 class="text-second">
                            {{ onAskDelete.truncated_pan }}
                        </h3>
                        <i class="fa-solid fa-mobile-screen-button fs-2 ms-2 text-third" v-if="onAskDelete.form_factors_name === 'DEVICE'"></i>
                    </div>
                    <div class="col-12 mb-4">
                        <p class="text-danger fw-bold">
                            {{ $t('Dashboard.BankCards.Modals.onAskDelete.info') }}
                        </p>
                        <p>
                            {{ $t('Dashboard.BankCards.Modals.onAskDelete.ask') }}
                        </p>
                    </div>
                    <div class="col-12 d-flex justify-content-between align-items-center flex-wrap">
                        <span class="text-first text-decoration-underline" role="button" @click="onAskDelete = null">
                            {{ $t('Dashboard.BankCards.Modals.onAskDelete.cancel') }}
                        </span>
                        <span class="btn btn-lg btn-danger" role="button" @click="removeBankCard">
                            {{ $t('Dashboard.BankCards.Modals.onAskDelete.confirm') }}
                        </span>
                    </div>
                </div>
            </template>
        </modal>
    </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import DataTable from "@/components/DataTables/BankCardsDataTable.vue"
import Modal from "@/components/Modal.vue"
export default {
    name: 'BankCards',
    components: {
        DataTable,
        Modal
    },
    computed: {
        ...mapState(['loader', 'account']),
        ...mapGetters(['apiPath', 'omsApiKey']),
    },
    data() {
        return {
            BankCards: null,
            onAskDelete: null
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer', 'setLoader']),
        removeBankCard() {
            this.setLoader(true)
            this.$http
                .post(`${this.apiPath}/bank_cards/remove`, { bank_cards_id: this.onAskDelete.id}, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then(() => {
                    this.onAskDelete = null
                    this.setLoader(false)
                    this.$router.go('/dashboard/travels/bank_cards')
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                    this.setLoader(false)
                })
        },
        async getBankCards() {
            this.setLoader(true)
            var BankCards = []

            try {
                const res = await this.$http.post(`${this.apiPath}/bank_cards/get`,
                {
                    accounts_id: this.account.id
                }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                var bank_cards = res.data
                for (var i = 0; i < bank_cards.length; i++) {
                    var bank_card = bank_cards[i]
                    bank_card.label = this.$formatLabel(bank_card.label)
                    bank_card.created = this.$formatDate(bank_card.created, this.account.locales_id, Intl.DateTimeFormat().resolvedOptions().timeZone)
                    bank_card.updated = this.$formatDate(bank_card.updated, this.account.locales_id, Intl.DateTimeFormat().resolvedOptions().timeZone)
                    BankCards.push(bank_card)
                }
                this.setLoader(false)
                return BankCards
            } catch (err) {
                this.setErrorFromServer(err.message)
                this.setLoader(false)
            }
        }
    },
    async mounted() {
        this.BankCards = await this.getBankCards()   
    }
}
</script>